import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checklist2-viewer-answer-status',
    templateUrl: './answer-status.component.html',
    styleUrls: ['./answer-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-viewer-answer-status' },
    standalone: false,
})
export class FiChecklist2ViewerAnswerStatusComponent {
    @Input() completedCount: number;
    @Input() notCompletedCount: number;
    @Input() deviationsCount: number;
    @Output() onDeviationsClick = new EventEmitter<void>();

    getProgressValue(): number {
        if (this.notCompletedCount === 0 && this.completedCount === 0) return 0;

        return Math.round((this.completedCount / (this.completedCount + this.notCompletedCount)) * 100);
    }

    deviationsClick() {
        this.onDeviationsClick.emit();
    }
}
